import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Filtri ")
const _hoisted_2 = {
  key: 0,
  class: "badge"
}
const _hoisted_3 = {
  key: 1,
  class: "material-icons"
}
const _hoisted_4 = { class: "modal-content p-d-flex p-flex-column p-mb-6 gap-8" }
const _hoisted_5 = { class: "p-d-flex p-ai-center gap-8" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 1M ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 2M ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 1W ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 2W ")
const _hoisted_10 = { class: "p-d-flex p-ai-center gap-8" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 1M ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 2M ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 1W ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 2W ")
const _hoisted_15 = { class: "flexbox-row" }

import { useI18n } from 'vue-i18n';
import UiButton from '../ui/UiButton.vue';
import { ref, reactive, nextTick, computed } from 'vue';
import UsersSearch from '../users-search/UsersSearch.vue';
import { MembershipFilters } from '@/api/types';
import moment from 'moment';
import { PadelUser } from '@/models/user.models';

interface Props {
  filters?: MembershipFilters;
}


export default _defineComponent({
  props: {
    filters: { type: null, required: false }
  } as unknown as undefined,
  emits: ["update:filters"] as unknown as undefined,
  setup(__props: {
  filters?: MembershipFilters;
}, { emit }: { emit: ({
  (e: 'update:filters', f: typeof currentFilters): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props
const { t } = useI18n();
const isVisible = ref(false);
const appliedFilters = ref(0);
const userSelected = ref<PadelUser>()


const currentFilters = reactive({ ...props.filters })



const statusFilterOptions = [
  { label: t('tutte'), value: null, disabled: false },
  { label: t('attive'), value: 'active', disabled: false },
  { label: t('sospese'), value: 'suspended', disabled: false },
  { label: t('cancellate'), value: 'cancelled', disabled: false }
];

const currentFiltersNumber = computed(() => Object.values(currentFilters).filter(el => !!el).length)

const resetFilters = () => {
  Object.keys(currentFilters).forEach((key) => {
    currentFilters[key] = undefined;
  })
  userSelected.value = undefined;
  nextTick(() => {
    emit('update:filters', { ...currentFilters });
    appliedFilters.value = currentFiltersNumber.value;
    isVisible.value = false;
  })
}

const setUser = (user?: PadelUser) => {
  userSelected.value = user;
  currentFilters.userId = user?.id;
}


const setActivationDateInterval = (weeks: number) => {
  const today = moment();
  const weeksAgo = today.clone().subtract(weeks, 'week');
  currentFilters.activationDateFrom = weeksAgo.toDate();
  currentFilters.activationDateTo = today.toDate();
}

const setExpirationDateInterval = (weeks: number) => {
  const today = moment();
  const weeksAgo = today.clone().subtract(weeks, 'week');
  currentFilters.expirationDateFrom = weeksAgo.toDate();
  currentFilters.expirationDateTo = today.toDate();
}


const applyFilters = () => {
  emit('update:filters', {
    ...currentFilters,
  });
  appliedFilters.value = currentFiltersNumber.value;
  isVisible.value = false;
}


return (_ctx: any,_cache: any) => {
  const _component_PadelCalendar = _resolveComponent("PadelCalendar")!
  const _component_PadelDropdown = _resolveComponent("PadelDropdown")!
  const _component_PadelInput = _resolveComponent("PadelInput")!
  const _component_DumbModal = _resolveComponent("DumbModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(UiButton, {
      onClick: _cache[1] || (_cache[1] = () => isVisible.value = true),
      variant: !appliedFilters.value ? 'primary' : 'danger'
    }, {
      "right-icon": _withCtx(() => [
        (appliedFilters.value)
          ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(appliedFilters.value), 1))
          : (_openBlock(), _createBlock("i", _hoisted_3, "filter_list"))
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["variant"]),
    (isVisible.value)
      ? (_openBlock(), _createBlock(_component_DumbModal, {
          key: 0,
          onHide: _cache[18] || (_cache[18] = () => isVisible.value = false),
          title: _unref(t)('filter_memberships')
        }, {
          footer: _withCtx(() => [
            _createVNode("div", _hoisted_15, [
              _createVNode(UiButton, {
                onClick: _cache[17] || (_cache[17] = () => isVisible.value = false),
                "is-text": "",
                size: "lg",
                class: "uppercase"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('abort')), 1)
                ]),
                _: 1
              }),
              _createVNode(UiButton, {
                onClick: resetFilters,
                "is-text": "",
                size: "lg",
                class: "p-ml-auto uppercase"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('reset_filters')), 1)
                ]),
                _: 1
              }),
              _createVNode(UiButton, {
                onClick: applyFilters,
                size: "lg",
                class: "p-ml-4 uppercase"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('apply')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", null, [
                _createVNode("span", null, _toDisplayString(_unref(t)('activation_date_interval')), 1),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_PadelCalendar, {
                    label: _unref(t)('rule_from'),
                    value: _unref(currentFilters).activationDateFrom,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_unref(currentFilters).activationDateFrom = $event))
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_PadelCalendar, {
                    label: _unref(t)('rule_to'),
                    value: _unref(currentFilters).activationDateTo,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_unref(currentFilters).activationDateTo = $event))
                  }, null, 8, ["label", "value"]),
                  _createVNode(UiButton, {
                    onClick: _cache[4] || (_cache[4] = () => setActivationDateInterval(4)),
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(UiButton, {
                    onClick: _cache[5] || (_cache[5] = () => setActivationDateInterval(8)),
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(UiButton, {
                    onClick: _cache[6] || (_cache[6] = () => setActivationDateInterval(1)),
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(UiButton, {
                    onClick: _cache[7] || (_cache[7] = () => setActivationDateInterval(2)),
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode("div", null, [
                _createVNode("span", null, _toDisplayString(_unref(t)('expiration_date_interval')), 1),
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_PadelCalendar, {
                    label: _unref(t)('rule_from'),
                    value: _unref(currentFilters).expirationDateFrom,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_unref(currentFilters).expirationDateFrom = $event))
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_PadelCalendar, {
                    label: _unref(t)('rule_to'),
                    value: _unref(currentFilters).expirationDateTo,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_unref(currentFilters).expirationDateTo = $event))
                  }, null, 8, ["label", "value"]),
                  _createVNode(UiButton, {
                    onClick: _cache[10] || (_cache[10] = () => setExpirationDateInterval(4)),
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(UiButton, {
                    onClick: _cache[11] || (_cache[11] = () => setExpirationDateInterval(8)),
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(UiButton, {
                    onClick: _cache[12] || (_cache[12] = () => setExpirationDateInterval(1)),
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(UiButton, {
                    onClick: _cache[13] || (_cache[13] = () => setExpirationDateInterval(2)),
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_component_PadelDropdown, {
                label: _unref(t)('membership_state'),
                options: statusFilterOptions,
                default: _unref(currentFilters).status,
                "onUpdate:default": _cache[14] || (_cache[14] = ($event: any) => (_unref(currentFilters).status = $event))
              }, null, 8, ["label", "default"]),
              _createVNode(UsersSearch, {
                onUserSelected: setUser,
                onClose: _cache[15] || (_cache[15] = () => setUser()),
                "search-user": userSelected.value
              }, null, 8, ["search-user"]),
              _createVNode(_component_PadelInput, {
                label: _unref(t)('search_description'),
                value: _unref(currentFilters).descriptionLike,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_unref(currentFilters).descriptionLike = $event)),
                "input-type": "text"
              }, null, 8, ["label", "value"])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})